module.exports = __webpack_public_path__ + "img/15.aab42c8a.png";